<template lang="html">
  <ext-form
    :formData="formData"
    :submitProxy="submitProxy"
    :loadProxy="loadProxy"
    submitBtnText="Создать"
  >
    <b-form-fieldset
      label="Роль"
    >
      <combo-box
        options="api/role"
        v-model="formData.role_id"
      />
    </b-form-fieldset>
    <b-form-fieldset
      label="Логин"
      :feedback = "errors.first('login')"
      :class="{'is-invalid': errors.has('login') }"
    >
      <input class="form-control" v-validate="'required|eng'" v-model="formData.login" name="login"/>
    </b-form-fieldset>

    <b-form-fieldset
      label="Пароль"
      :feedback = "errors.first('password')"
      :class="{'is-invalid': errors.has('password') }"
      v-if = "!this.loadProxy"
    >
      <input class="form-control" type="password" v-model="formData.password" name="password"/>
    </b-form-fieldset>

    <b-form-fieldset
      label="Имя"
      :feedback = "errors.first('name')"
      :class="{'is-invalid': errors.has('name') }"
    >
      <input class="form-control" v-validate="'letters_only'" v-model="formData.name" name="name"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Фамилия"
      :feedback = "errors.first('surname')"
      :class="{'is-invalid': errors.has('surname') }"
    >
      <input class="form-control" v-validate="'letters_only'" v-model="formData.surname" name="surname"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Отчество"
      :feedback = "errors.first('patronymic')"
      :class="{'is-invalid': errors.has('patronymic') }"
    >
      <input class="form-control" v-validate="'letters_only'" v-model="formData.patronymic" name="patronymic"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Дата рождения"
      :feedback = "errors.first('birthdate')"
      :class="{'is-invalid': errors.has('birthdate') }"
    >
      <InlineDatepicker v-model="formData.birthdate" v-validate="'required|date'" name="birthdate"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Email"
      :class="{'is-invalid': errors.has('email') }"
      :feedback = "errors.first('email')"
    >
      <input class="form-control" v-model.trim.lazy="formData.email" v-validate="'email'" name="email"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Контактный телефон"
      :class="{'is-invalid': errors.has('tel') }"
      :feedback = "errors.first('tel')"
    >
      <input class="form-control" v-mask="'+7 (###) ###-##-##'" v-model="formData.tel" name="tel"/>
    </b-form-fieldset>
  </ext-form>
</template>

<script>
import ExtForm from '@/components/ExtForm'
import InlineDatepicker from '@/components/InlineDatepicker'
import ComboBox from '@/components/ComboBox'

export default {
  components: {
    ExtForm,
    InlineDatepicker,
    ComboBox
  },
  props: ['loadProxy', 'submitProxy', 'extraData'],
  created () {
    if (!this.loadProxy) {
      this.$set(this, 'password', '')
    }
  },
  data () {
    return {
      formData: {
        role_id: '',
        name: '',
        surname: '',
        patronymic: '',
        birthdate: '',
        email: '',
        tel: '',
        login: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FullAccountForm.vue?654a94bd